import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/auralux.css';
import App from './App';
import { ensureApiConfig } from './lib/apiBase';

const root = ReactDOM.createRoot(document.getElementById('root'));
ensureApiConfig().then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
